import React from "react";
import { useSelector } from "react-redux";
import { Box, Stack } from "@mui/material";
import PageTitle from "./PageTitle";
import { useLocation } from "react-router-dom";
import BottlerSelection from "./BottlerSelection";
import MFBottlerSelection from "../../../Pages/MarketForecast/MFDashboard/MFBottlerSelection";
import FGBottlerSelection from "../../../Pages/FGInventory/FGDashboard/FGBottlerSelection";
import BPBottlerSelection from "../../../Pages/BusinessPlan/BPDashboard/BPBottlerSelection";
import CIBottlerSelection from "../../../Pages/ConcentrateInventory/CIDashboard/CIBottlerSelection";
import PRBottlerSelection from "../../../Pages/ProductionRequirement/PRDashboard/PRBottlerSelection";

const TopSection = (props) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const allowedPaths = ["/bf-dashboard", "/bf-history", "/power-bi-reports"];
  const MFallowedPaths = ["/bmf-dashboard", "/bmf-history"];
  const FGallowedPaths = ["/fg-dashboard", "/fg-history"];
  const BPallowedPaths = ["/bp-dashboard", "/bp-history"];
  const CIallowedPaths = ["/ci-dashboard", "/ci-history"];
  const PRallowedPaths = ["/pr-dashboard", "/pr-history"];

  const isAllowedPath = allowedPaths.some((path) => currentPath.includes(path));
  const isMFallowedPaths = MFallowedPaths.some((path) =>
    currentPath.includes(path),
  );
  const isFGallowedPaths = FGallowedPaths.some((path) =>
    currentPath.includes(path),
  );
  const isBPallowedPaths = BPallowedPaths.some((path) =>
    currentPath.includes(path),
  );
  const isCIallowedPaths = CIallowedPaths.some((path) =>
    currentPath.includes(path),
  );
  const isPRallowedPaths = PRallowedPaths.some((path) =>
    currentPath.includes(path),
  );

  return (
    <Stack>
      <Stack direction="row" justifyContent="space-between">
        <PageTitle pageTitle={props.title}></PageTitle>
        <Box sx={{ margin: "5px", marginLeft: "auto" }}>
          {isAllowedPath && <BottlerSelection />}
          {isMFallowedPaths && <MFBottlerSelection />}
          {isFGallowedPaths && <FGBottlerSelection />}
          {isBPallowedPaths && <BPBottlerSelection />}
          {isCIallowedPaths && <CIBottlerSelection />}
          {isPRallowedPaths && <PRBottlerSelection />}
        </Box>
      </Stack>
    </Stack>
  );
};

export default TopSection;
